// extracted by mini-css-extract-plugin
module.exports = {"picture":"Picture_picture__23XJv","actions":"Picture_actions__L0W_6","btn":"Picture_btn__1obhM"};